import axiosPlataformaClient from '../../plugins/axios.plataforma.plugin';

export default {
  get(url) {
    return axiosPlataformaClient.custAxios().get(url);
  },
  put(url, body) {
    return axiosPlataformaClient.custAxios().put(url, body);
  },
  post(url, body) {
    return axiosPlataformaClient.custAxios().post(url, body);
  },
  delete(url) {
    return axiosPlataformaClient.custAxios().delete(url);
  }
};
